import { HttpBackend, HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { Observable, of } from 'rxjs'
import { catchError, shareReplay, switchMap } from 'rxjs/operators'

type I18nManifest = Record<string, string>

@Injectable()
export class I18nHashTranslateLoader implements TranslateLoader {
  private readonly prefix = '/assets/i18n/'
  private readonly manifestUrl = `${this.prefix}i18n-manifest.webmanifest`
  private readonly http: HttpClient
  private manifest$?: Observable<I18nManifest | null>

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend)
  }

  getTranslation(lang: string): Observable<TranslationObject> {
    const fallbackFile = `${lang}.json`

    return this.getManifest().pipe(
      switchMap((manifest) => {
        const file = manifest?.[lang] ?? fallbackFile

        return this.http.get<TranslationObject>(`${this.prefix}${file}`)
      })
    )
  }

  private getManifest(): Observable<I18nManifest | null> {
    if (!this.manifest$) {
      this.manifest$ = this.http.get<I18nManifest>(this.manifestUrl).pipe(
        catchError(() => of(null)),
        shareReplay(1)
      )
    }

    return this.manifest$
  }
}
